import { ExamQuestionType, Question } from "@types";
import { SingleChoiceQuestion } from "./question-form-type/SingleChoiceQuestion";
import { MultipleChoicesQuestion } from "./question-form-type/MultipleChoicesQuestion";
import { ShortAnswerQuestion } from "./question-form-type/ShortAnswerQuestion";
import { CorrectIncorrectQuestion } from "./question-form-type/CorrectIncorrectQuestion";
import { EssayQuestion } from "./question-form-type/EssayQuestion";
import { ImageChoiceQuestion } from "./question-form-type/ImageChoiceQuestion";
import { ConnectingQuestion } from "./question-form-type/ConnectingQuestion";
import { FormInstance } from "antd";
import { MultipleImageChoiceQuestion } from "./question-form-type/MultipleImageChoiceQuestion";
import { RcFile } from "antd/es/upload";
import { setTimeWithSeconds } from "../helpers";

export const chooseFormByQuestionType = (questionType: ExamQuestionType, form: FormInstance, question?: Question, ) => {
    

    if (questionType === ExamQuestionType.SingleChoice) {
        return <SingleChoiceQuestion question={question}/>
    } else if (questionType === ExamQuestionType.MultipleChoices) {
        return <MultipleChoicesQuestion />
    } else if (questionType === ExamQuestionType.ShortAnswer) {
        return <ShortAnswerQuestion />
    } else if (questionType === ExamQuestionType.CorrectIncorrect) {
        return <CorrectIncorrectQuestion form={form} question={question}/>
    } else if (questionType === ExamQuestionType.EssayQuestion) {
        return <EssayQuestion form={form}/>
    } else if (questionType === ExamQuestionType.ImageChoice) {
        return <ImageChoiceQuestion form={form} question={question}/>
    } else if (questionType === ExamQuestionType.ImageMultipleChoice) {
        return <MultipleImageChoiceQuestion form={form} question={question}/>
    }else {
        return <ConnectingQuestion />
    }
}

export const setFormByValues = (question: Question, questionForm: FormInstance) => {  
    const tempQuestion = {
        ...question
    }
    delete tempQuestion.attachments;  
    questionForm.setFieldsValue(tempQuestion);
    questionForm.setFieldValue("attachments", question.attachments?.map((attachment) => ({uid: attachment.id, name: attachment.name, status: "done", url: attachment.path})))
    questionForm.setFieldValue("user.id", question.user?.id);
    questionForm.setFieldValue("categories", question.categories.map((category) => category.id));
    questionForm.setFieldValue("state", question?.state === 1 ? true : false);
    questionForm.setFieldValue("timeToAnswer", setTimeWithSeconds(question.timeToAnswer));
    if (question.timeToAnswer) {
        questionForm.setFieldValue("timeRestriction", true);
    }
    if (question.questionType.id === ExamQuestionType.CorrectIncorrect) {
        questionForm.setFieldValue("answers.isCorrect", question.answers[0].isCorrect);
        questionForm.setFieldValue("answers.value", question.answers[0].value);
    } else if (question.questionType.id === ExamQuestionType.ImageChoice || question.questionType.id === ExamQuestionType.ImageMultipleChoice) {
        // questionForm.setFieldValue("base64Images", question.b);
    }

}

export const getBase64 = (file: RcFile): Promise<string> =>
new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result as string);
  reader.onerror = (error) => reject(error);
});

export const extractImageExtension = (dataString: string): string | null => {
    const match = dataString.match(/data:image\/(.*?);base64,/);
    return match ? match[1] : null;
};